/* tslint:disable */
/* eslint-disable */
/* @relayHash 1d8f476d075693827eeacdb180e50707 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SimulatorImagesReviewModalQueryVariables = {
    uuid: string;
    monthID: string;
};
export type SimulatorImagesReviewModalQueryResponse = {
    readonly delegate: {
        readonly firstName: string;
        readonly simulator: {
            readonly imageHistory: {
                readonly edges: ReadonlyArray<{
                    readonly uuid: string;
                    readonly start: string;
                    readonly " $fragmentRefs": FragmentRefs<"SimulatorApp_imageResult" | "SimulatorHistoryItem_result">;
                } | null> | null;
                readonly pageInfo: {
                    readonly limit: number;
                    readonly offset: number;
                    readonly given: number;
                    readonly total: number;
                } | null;
            };
        } | null;
    } | null;
};
export type SimulatorImagesReviewModalQuery = {
    readonly response: SimulatorImagesReviewModalQueryResponse;
    readonly variables: SimulatorImagesReviewModalQueryVariables;
};



/*
query SimulatorImagesReviewModalQuery(
  $uuid: UUID!
  $monthID: String!
) {
  delegate(uuid: $uuid) {
    firstName
    simulator {
      imageHistory(monthID: $monthID, page: {limit: 300}) {
        edges {
          uuid
          start
          ...SimulatorApp_imageResult
          ...SimulatorHistoryItem_result
        }
        pageInfo {
          limit
          offset
          given
          total
        }
      }
    }
  }
}

fragment SimulatorApp_imageResult on ImageResult {
  identifiedStatus
  uuid
  image {
    threat {
      uuid
    }
  }
  ...SimulatorDisplay_imageResult
}

fragment SimulatorDisplay_imageResult on ImageResult {
  uuid
  identifiedStatus
  image {
    normal {
      images {
        topURL
        sideURL
      }
    }
    threat {
      threatXray {
        images {
          topURL
          sideURL
        }
      }
      topPosition {
        x
        y
        scale
        rotation
      }
      sidePosition {
        x
        y
        scale
        rotation
      }
    }
  }
}

fragment SimulatorHistoryItem_result on ImageResult {
  uuid
  start
  end
  isCorrect
  identifiedStatus
  identification {
    isSearch
  }
  image {
    normal {
      images {
        topURL
      }
    }
    threat {
      threatXray {
        images {
          topURL
        }
      }
      topPosition {
        x
        y
        scale
        rotation
      }
    }
    alwaysSearch
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "monthID",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "monthID",
            "variableName": "monthID"
        } as any),
        ({
            "kind": "Literal",
            "name": "page",
            "value": {
                "limit": 300
            }
        } as any)
    ], v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "start",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "limit",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "offset",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "given",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v7 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "images",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageURLs",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "topURL",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sideURL",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ], v8 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "x",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "y",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "scale",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "rotation",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SimulatorImagesReviewModalQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "simulator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Simulator",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "imageHistory",
                                    "storageKey": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "ImageHistoryPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ImageResult",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "SimulatorApp_imageResult",
                                                    "args": null
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "SimulatorHistoryItem_result",
                                                    "args": null
                                                }
                                            ]
                                        },
                                        (v6 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SimulatorImagesReviewModalQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "simulator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Simulator",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "imageHistory",
                                    "storageKey": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "ImageHistoryPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ImageResult",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "identifiedStatus",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "image",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PackagedImage",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "threat",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ThreatBundle",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "threatXray",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ThreatXray",
                                                                    "plural": false,
                                                                    "selections": (v7 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "topPosition",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ThreatPosition",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "sidePosition",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ThreatPosition",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/)
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "normal",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "NormalXray",
                                                            "plural": false,
                                                            "selections": (v7 /*: any*/)
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "alwaysSearch",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "end",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isCorrect",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "identification",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Identification",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isSearch",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        (v6 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SimulatorImagesReviewModalQuery",
            "id": null,
            "text": "query SimulatorImagesReviewModalQuery(\n  $uuid: UUID!\n  $monthID: String!\n) {\n  delegate(uuid: $uuid) {\n    firstName\n    simulator {\n      imageHistory(monthID: $monthID, page: {limit: 300}) {\n        edges {\n          uuid\n          start\n          ...SimulatorApp_imageResult\n          ...SimulatorHistoryItem_result\n        }\n        pageInfo {\n          limit\n          offset\n          given\n          total\n        }\n      }\n    }\n  }\n}\n\nfragment SimulatorApp_imageResult on ImageResult {\n  identifiedStatus\n  uuid\n  image {\n    threat {\n      uuid\n    }\n  }\n  ...SimulatorDisplay_imageResult\n}\n\nfragment SimulatorDisplay_imageResult on ImageResult {\n  uuid\n  identifiedStatus\n  image {\n    normal {\n      images {\n        topURL\n        sideURL\n      }\n    }\n    threat {\n      threatXray {\n        images {\n          topURL\n          sideURL\n        }\n      }\n      topPosition {\n        x\n        y\n        scale\n        rotation\n      }\n      sidePosition {\n        x\n        y\n        scale\n        rotation\n      }\n    }\n  }\n}\n\nfragment SimulatorHistoryItem_result on ImageResult {\n  uuid\n  start\n  end\n  isCorrect\n  identifiedStatus\n  identification {\n    isSearch\n  }\n  image {\n    normal {\n      images {\n        topURL\n      }\n    }\n    threat {\n      threatXray {\n        images {\n          topURL\n        }\n      }\n      topPosition {\n        x\n        y\n        scale\n        rotation\n      }\n    }\n    alwaysSearch\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '934a2d70bceabd2b0c97a9c188621075';
export default node;
